// extracted by mini-css-extract-plugin
module.exports = {"loading":"styles_loading__95K48"};